/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'share-modal.accordion-button-label':
    '{entity, select, project {プロジェクトに関する週次最新情報を受け取るユーザー} goal {ゴールの週次最新情報を受け取るユーザー} other {週次最新情報を受け取るユーザー}}',
  'share-modal.add-as-follower-checkbox-label': 'フォロワーとして追加',
  'share-modal.add-as-follower-checkbox-tooltip':
    '{entity, select, project {フォロワーには、プロジェクトの週次最新情報がダイジェストで届きます} goal {フォロワーには、ゴールの週次最新情報がダイジェストで届きます} other {フォロワーには、週次最新情報がダイジェストで届きます}}',
  'share-modal.all-tab-label': 'すべて',
  'share-modal.contributors-tab-label': '投稿者',
  'share-modal.followers-tab-label': 'フォロワー',
  'share-modal.followers-title': 'フォロワー',
  'share-modal.footer.access-level-disclaimer':
    '{entity, select, project {ワークスペースへのアクセス権があるユーザーは誰でもこのプロジェクトを表示できます。} goal {ワークスペースへのアクセス権があるユーザーは誰でもこのゴールを表示できます。} other {ワークスペースへのアクセス権があるユーザーは誰でもこれを表示できます。}}',
  'share-modal.footer.access-level-private-disclaimer':
    '{entity, select, project {非公開プロジェクト} goal {非公開ゴール} other {}}',
  'share-modal.footer.copy-link-button': 'リンクをコピー',
  'share-modal.footer.copy-link-button.copied-tooltip': 'コピーしました！',
  'share-modal.footer.copy-link-button.tooltip':
    '{entity, select, project {リンクをプロジェクトにコピー} goal {リンクをゴールにコピー} other {リンクのコピー先 }}',
  'share-modal.modal.user-picker.add-more-placeholder': 'ユーザーをさらに追加',
  'share-modal.share-button': '共有',
  'share-modal.share-title': '共有',
  'share-modal.user-item.can-edit-label': '編集可能',
  'share-modal.user-picker.placeholder': '検索してユーザーを招待',
  'shareModal.followers-empty-state.default-title': '主要な関係者が追加されていません。',
  'shareModal.followers-empty-state.goal-cta':
    '関係者をフォロワーとして追加するか、Slack または Microsoft Teams のチャンネルを接続し、ゴールに関する最新情報を関係者が月次ダイジェストで受け取れるようにしましょう',
  'shareModal.followers-empty-state.project-cta':
    '主要なチームと関係者をフォロワーとして追加し、常に情報を共有しましょう。チャンネルを接続すれば、最新情報を直接チャットで配信できます。',
  'shareModal.followers-empty-state.project-title': 'フォロワーを追加して広範囲のユーザーに情報を伝えましょう',
};
